import { AccountId, Conversation, CONVERSATION_TYPES } from "@ollie-sports/models";
import { SimpleQuery } from "@ollie-sports/firebase-lift";

export function getAccountConversationsForAccountIdFragment(p: { accountId: AccountId }): SimpleQuery<Conversation> {
  return { where: [{ accounts: { [p.accountId]: ["==", true] } }, { conversationType: ["==", CONVERSATION_TYPES.accounts] }] };
}

// i18n certified - complete
